<template lang="pug">
div
  SubHeader(apiname='contact',headname='お問い合わせ')




</template>

<script>
import SubHeader from '@/views/components/swan/common/SubHeader'
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    SubHeader
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/contact/list.vue